module.exports = __webpack_public_path__ + "img/wa-mods.f4611284.webp";